/* Shared WD cart count and floating cart; does not intercept theme cart calls. */
(function(){
  'use strict';
  if(window.__wdCartUiV3)return;window.__wdCartUiV3=true;
  var floating=document.getElementById('wd-floating-cart');if(!floating)return;
  var base=floating.getAttribute('data-cart-url')||'/cart';
  var path=base.replace(/\/$/,'')+'.js';
  var requestId=0;
  function money(minor){
    var currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'PKR';
    try{return new Intl.NumberFormat(document.documentElement.lang||'en-PK',{style:'currency',currency:currency,maximumFractionDigits:2}).format((minor||0)/100);}
    catch(e){return 'Rs. '+((minor||0)/100).toLocaleString();}
  }
  function update(cart){
    var count=Number(cart.item_count)||0;
    document.querySelectorAll('[data-wd-cart-count]').forEach(function(el){el.textContent=count;});
    document.querySelectorAll('[data-wd-cart-items]').forEach(function(el){el.textContent=count;});
    document.querySelectorAll('[data-wd-cart-subtotal]').forEach(function(el){el.textContent=money(cart.total_price);});
    document.querySelectorAll('.wd-cart-badge').forEach(function(el){el.textContent=count;el.classList.toggle('show',count>0);});
    floating.classList.toggle('is-visible',count>0);
  }
  function refresh(){
    var id=++requestId;
    return fetch(path,{credentials:'same-origin',cache:'no-store',headers:{'Accept':'application/json'}})
      .then(function(r){if(!r.ok)throw Error('Cart unavailable');return r.json();})
      .then(function(data){if(id===requestId)update(data);}).catch(function(){/* Keep last known count. */});
  }
  ['cart:refresh','wd:cart-updated','cart:change','cart:updated'].forEach(function(eventName){
    document.addEventListener(eventName,refresh);window.addEventListener(eventName,refresh);
  });
  document.addEventListener('visibilitychange',function(){if(!document.hidden)refresh();});
  window.addEventListener('pageshow',refresh);
  refresh();
})();
